<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ text.title }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-row class="pl-4 pr-4">
        <v-col class="py-1">
          <v-slider
            v-model="opacity"
            :label="text.sliderLabel"
            max="100"
            min="0"
            step="10"
            hide-details="auto"
            always-dirty
            :thumb-size="24"
          ></v-slider>
        </v-col>
      </v-row>
      <v-divider class="mt-4 mb-4"></v-divider>
      <span class="px-2"> {{ text.subtitle }} </span>
      <v-row class="pl-6 pr-4 py-2">
        <span class="px-2"> {{ text.partitonLabel }} </span>
        <v-btn
          rounded
          depressed
          :outlined="!isRadarNumber(1)"
          small
          :disabled="isNotPlay"
          color="success"
          @click="setRadarNumber(1)"
        >
          <span>{{ text.number1 }}</span>
        </v-btn>
        <v-btn
          class="ms-2"
          rounded
          depressed
          :outlined="!isRadarNumber(4)"
          small
          :disabled="isNotPlay"
          color="success"
          @click="setRadarNumber(4)"
        >
          <span>{{ text.number4 }}</span>
        </v-btn>
      </v-row>
      <v-row class="pl-6 pr-4">
        <span class="px-2"> {{ text.denoteLabel }} </span>
        <v-btn
          rounded
          depressed
          :outlined="!isRadarInterval(5)"
          :disabled="isRadarNumber(1)"
          small
          color="success"
          @click="setRadarInterval(5)"
        >
          <span>{{ text.interval5 }}</span>
        </v-btn>
        <v-btn
          class="ms-2"
          rounded
          depressed
          :outlined="!isRadarInterval(30)"
          :disabled="isRadarNumber(1)"
          small
          color="success"
          @click="setRadarInterval(30)"
        >
          <span>{{ text.interval30 }}</span>
        </v-btn>
        <v-btn
          class="ms-2"
          rounded
          depressed
          :outlined="!isRadarInterval(60)"
          :disabled="isRadarNumber(1)"
          small
          color="success"
          @click="setRadarInterval(60)"
        >
          <span>{{ text.interval60 }}</span>
        </v-btn>
      </v-row>
      <v-divider class="mt-4 mb-4"></v-divider>
      <v-row>
        <v-col class="pa-0">
          <v-col class="py-2">
            <span class="px-2"> {{ text.snsLavel }} </span>
            <span class="pl-2">
              <v-btn icon @click="postFacebook()">
                <img
                  id="sns-fb-btn"
                  src="/kawabou/img/sns_icons/facebook.png"
                />
              </v-btn>
              <v-btn icon class="ms-2" @click="postTwitter()">
                <div v-if="dispOverlay" class="com-modal com-modal-overlay">
                  <v-overlay data-html2canvas-ignore="true">
                    <v-progress-circular
                      indeterminate
                      :size="60"
                      :width="8"
                    ></v-progress-circular>
                  </v-overlay>
                </div>
                <img id="sns-tw-btn" src="/kawabou/img/sns_icons/twitter.png" />
              </v-btn>
              <v-btn icon class="ms-2" @click="textLine()">
                <img id="sns-line-btn" src="/kawabou/img/sns_icons/line.png" />
              </v-btn>
            </span>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [pc]レーダ雨量画面 ４枚表示カード
 * RdNumber.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import PageLog from "../../lib/pageLog.js";
export default {
  name: "rd-number",
  mixins: [mixin],
  data() {
    return {
      dispOverlay: false,
      /** 文字列リソース */
      text: {
        title: "表示設定",
        number1: "１枚表示",
        number4: "４枚表示",
        interval5: "５分間隔",
        interval30: "３０分間隔",
        interval60: "６０分間隔",
        sliderLabel: "透過率",
        subtitle: "分割表示",
        partitonLabel: "表示切替",
        denoteLabel: "表示間隔",
        snsLavel: "SNS共有",
        hint: "表示している画面をSNSに共有できます。",
      },
    };
  },
  computed: {
    /** 履歴再生/準備中以外状態 */
    isNotPlay: {
      get() {
        return !this.$store.getters["radar/isNotPlay"];
      },
    },
    /** slider透過率 */
    opacity: {
      get() {
        return this.$store.state.radar.radarOpacity;
      },
      set(val) {
        this.$store.commit("radar/setOpacity", val);
        this.replaceRadarQueryForPc();
      },
    },
    /** レーダ種別 */
    radarType: {
      get() {
        return this.$store.state.radar.radarType;
      },
    },
    /** SNS地域名 */
    areaName: {
      get() {
        let map = this.$store.state.map;
        return map.prefName + map.townName;
      },
    },
    /** LINE投稿テキスト */
    lineText: {
      get() {
        return this.$store.state.sns.lineText;
      },
    },
  },
  imageTimeOut: {
    get() {
      return this.$store.state.app.config.snsConfig.twitter.imageTimeOut;
    },
  },
  methods: {
    /** 地図枚数設定 */
    setRadarNumber(val) {
      // 4枚表示のときのみアクセスログ出力
      if (val == 4) {
        PageLog.log({
          page_log: "radar_4",
          lat: this.$store.state.map.center[0],
          lon: this.$store.state.map.center[1],
          zm: this.$store.state.map.zoom,
          rader_sb: this.$store.state.radar.radarType,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
      this.$store.commit("radar/resetHistoryPlay");
      this.$store.commit("radar/setNumber", val);
      this.replaceRadarQueryForPc();
    },
    /** 地図枚数取得 */
    isRadarNumber(val) {
      let radarNumber = this.$store.state.radar.radarNumber;
      return radarNumber === val;
    },
    /** 地図表示間隔設定 */
    setRadarInterval(val) {
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_4",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.commit("radar/setInterval", val);
      this.replaceRadarQueryForPc();
    },
    /** 地図表示間隔取得 */
    isRadarInterval(val) {
      let radarInterval = this.$store.state.radar.radarInterval;
      return radarInterval === val;
    },
    /** FaceBook投稿 */
    postFacebook() {
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "fb",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/postFacebook", { url: location.href });
    },
    /** Twitter投稿 */
    async postTwitter() {
      this.dispOverlay = true;
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "tw",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/setTextRadar", {
        url: location.href,
        area: this.areaName,
      });
      await this.$store.dispatch("sns/getCapture", { type: "radar", imageTimeOut: this.imageTimeOut });
      this.getRequestToken();
      this.dispOverlay = false;
    },
    /** Twitterリクエストトークンを取得 */
    getRequestToken() {
      this.$log.debug("[RdNumber] getRequestToken()");
      const subWin = window.open("", "_blank");
      this.$store.dispatch("sns/getRequestToken", {subWin});
    },
    /** LINE投稿テキスト生成 */
    textLine() {
      this.$store.dispatch("sns/textLineRadar", {
        area: this.areaName,
      });
      this.$store.commit("sns/setType", "radar");
    },
    /** LINE投稿 */
    postLine() {
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "ln",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/postLine", {
        lat: this.$route.query["clat"],
        lon: this.$route.query["clon"],
        mode: "pc",
      });
    },
  },
  watch: {
    /** LINE投稿テキスト */
    lineText() {
      if (this.lineText != null) {
        this.postLine();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#sns-fb-btn {
  height: 32px;
  width: 32px;
  margin-left: 10px;
  margin-right: 10px;
}
#sns-tw-btn {
  height: 32px;
  width: 32px;
  margin-left: 10px;
  margin-right: 10px;
}
#sns-line-btn {
  height: 32px;
  width: 32px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
